import { forwardRef, HTMLProps, Ref } from "react";

export type TextareaProps = HTMLProps<HTMLTextAreaElement> & {
  inErrorState?: boolean;
};

export const Textarea = forwardRef((props: TextareaProps, ref: Ref<HTMLTextAreaElement>) => {
  const { inErrorState, className, ...textareaProps } = props;
  const baseClasses = inErrorState
    ? "border mt-1 rounded py-2.5 pt-3 px-3 w-full text-sm bg-red-50 focus-visible:border-red-600 focus:outline-none border-red-500"
    : "border mt-1 rounded py-2.5 pt-3 px-3 w-full text-sm bg-gray-50 focus-visible:border-gray-400 focus:outline-none";
  return (
    <textarea ref={ref} {...textareaProps} className={className ? `${baseClasses} ${className}` : baseClasses} />
  );
});
